import { Trans } from 'react-i18next';

import giftBoxImg from '../../../assets/gift/green-present-box.png';
import styles from '../Onboarding.module.scss';

export const BonusTooltip = () => {
  return (
    <div className={styles.bonusTooltip}>
      <p className={styles.bonusTooltipText} data-testid="onboarding-bonus-tooltip-text">
        <Trans components={{ intro: <span />, bold: <strong /> }} i18nKey="onboarding.claimDailyBonus" />
      </p>
      <img alt="gift box" src={giftBoxImg} />
    </div>
  );
};
